module.exports = __webpack_public_path__ + "static/media/Elan_Elites.78195c02.jpg";